import { PINTEREST_BUTTON_SELECTOR } from '../../../constants';

export default (event) => {
  if (!event) return false;

  return event.target.closest(PINTEREST_BUTTON_SELECTOR);
};
